import { render, staticRenderFns } from "./NorxSituations.vue?vue&type=template&id=1b5ffd73&lang=pug"
import script from "./NorxSituations.vue?vue&type=script&lang=js"
export * from "./NorxSituations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports